import * as React from 'react';
import styled from 'styled-components';

interface PencilIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

export const PencilIcon: React.FC<PencilIconProps> = ({
  className,
  ...props
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
    className={className || ''}
  >
    <circle opacity="0.2" cx="12" cy="12" r="12" />
    <path d="M13 7c-0.5 0-1 0.2-1.4 0.6l-4 4C7.2 12 7 12.5 7 13v2c0 0.5 0.2 1 0.6 1.4C8 16.8 8.5 17 9 17h2c0.5 0 1-0.2 1.4-0.6l4-4c0.8-0.8 0.8-2 0-2.8l-2-2C14 7.2 13.5 7 13 7zM13 9l2 2 -4 4H9v-2L13 9" />
  </svg>
);

export default styled(PencilIcon)`
  circle {
    fill: ${({ theme }) => theme.colors.inputBackgroundAlternate};
  }
  path {
    fill: ${({ theme }) => theme.colors.primary};
  }
`;
